import { useState, useEffect } from "react";

import { useQuery, useQueryClient } from "@tanstack/react-query";

import { AuthContext } from "../Context";

const AuthProvider = ({ children }) => {
  const initCache = (key, parse) => {
    const payload = localStorage.getItem(key) ?? null;

    return parse ? JSON.parse(payload) : payload;
  };

  const [token, setToken] = useState(initCache("token"));
  const [user, setUser] = useState(initCache("user", true));

  const queryClient = useQueryClient();

  const loginUser = ({ token, user }) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));

    setToken({ token });
    setUser(user);
  };

  const logoutUser = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    setToken(null);
    setUser(null);
  };

  const revokeToken = () => logoutUser();

  const refetchMutation = useQuery({
    queryKey: ["auth/check"],
    enabled: false,
  });

  useEffect(() => {
    if (refetchMutation.isSuccess) {
      console.log("refetched");
    }
  }, [refetchMutation.isSuccess]);

  useEffect(() => {
    if (refetchMutation.isError) {
      localStorage.removeItem("token");
      logoutUser();
      queryClient.invalidateQueries({ queryKey: ["auth"] });
    }
  }, [refetchMutation.isError, queryClient]);

  const context = {
    authenticated: Boolean(token && user),
    token,
    user,
    loginUser,
    logoutUser,
    revokeToken,
    refetchMutation,
  };

  return (
    <AuthContext.Provider value={context}>{children}</AuthContext.Provider>
  );
};

export default AuthProvider;
